import { Form, Tabs } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { FormLabels, CustomEditorInput, CustomText } from 'src/components'
import { getDescriptionLanguages, isHtmlTextEmpty } from 'src/core/helpers'
import { PosibleLocale, ProjectTaxDescriptionsPayload } from 'src/core/models'
import ProjectFormButtonContinue from '../ProjectFormButtonContinue/ProjectFormButtonContinue'
import {
  isTaxDescriptionErrorVisibleSelector,
  setProjectFormTaxDescriptionsValue,
  taxRefliefInfoValuesSelector,
  setProjectFormItemValue,
} from 'src/features'
const { TabPane } = Tabs

const ProjectFormTaxRelief: React.FC = () => {
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const { t, i18n: { language } } = useTranslation()
  const languages = getDescriptionLanguages(t)
  const formValues = useAppSelector(taxRefliefInfoValuesSelector)
  const isTaxErrorVisible = useAppSelector(isTaxDescriptionErrorVisibleSelector)

  const onFinish = (values: ProjectTaxDescriptionsPayload) => {
    if (isTaxErrorVisible) return
    dispatch(setProjectFormTaxDescriptionsValue(values))
    dispatch(setProjectFormItemValue({ key: 'activeStep', value: 'STOCK' }))
  }

  const handleChange = (text: string, locale: PosibleLocale) => {
    const value = isHtmlTextEmpty(text) ? null : text
    dispatch(setProjectFormItemValue({ key: `tax_info_${locale}`, value }))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['tax_info_en']: formValues.tax_info_en,
      ['tax_info_es']: formValues.tax_info_es,
      ['tax_info_fr']: formValues.tax_info_fr,
      ['tax_info_ko']: formValues.tax_info_ko,
      ['tax_info_de']: formValues.tax_info_de,
      ['tax_info_pt']: formValues.tax_info_pt,
      ['tax_info_it']: formValues.tax_info_it,
      ['tax_info_pl']: formValues.tax_info_pl,
      ['tax_info_zh']: formValues.tax_info_zh,
    })
  }, [form, formValues])

  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      {/* Tax Labels */}
      <FormLabels
        title={t('Projects.TaxDescription')}
        subtitle={t('Projects.TaxLabel')}
        thirdLabel={t('Projects.Form.DescriptionSubLabel')}
      />

      {/* Descriptions */}
      <Tabs defaultActiveKey={language} size={'small'}>
        {languages.map((item) => (
          <TabPane tab={item.label} key={item.locale}>
            <CustomEditorInput
              name={`tax_info_${item.locale}`}
              placeholder={t('Projects.Form.TextLabel')}
              onChange={(value: string) => handleChange(value, item.locale)}
            />
          </TabPane>
        ))}
      </Tabs>

      {isTaxErrorVisible && <CustomText
        label={t('Projects.OneDescRequired')}
        type='danger'
      />}

      <ProjectFormButtonContinue />
    </Form>
  )
}

export default ProjectFormTaxRelief
